import React from "react";
import { brandAssets } from "../data/site";
type BrandMarkProps = {
  compact?: boolean;
  light?: boolean;
};
export function BrandMark({
  compact = false,
  light = false
}: BrandMarkProps) {
  return <a href="#top" className="group inline-flex items-center gap-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-bronze" aria-label="Leo Tovar Method, back to top" data-id="element-39" data-mp="tij1kec50mb6">
      <span className={`grid place-items-center transition-transform duration-200 ease-out motion-safe:group-hover:rotate-2 motion-safe:group-hover:scale-[1.03] ${compact ? "h-10 w-10" : "h-12 w-12"}`} aria-hidden="true" data-id="element-40" data-mp="1m6on33b0mfc2">
        <img src={brandAssets.logo} alt="" className="h-full w-full object-contain" data-id="element-41" data-mp="1cg3p9i361eu7" />
      </span>
      <span className={light ? "text-cream" : "text-ink"} data-id="element-42" data-mp="17ittzlt3i8yg">
        <span className="block text-[11px] font-bold uppercase leading-none tracking-[0.22em]" data-id="element-43" data-mp="24zj2fycjw9gt">Leo Tovar</span>
        <span className="mt-1 block text-[8px] uppercase leading-none tracking-[0.32em] opacity-70" data-id="element-44" data-mp="206zdk58exrwp">Method</span>
      </span>
    </a>;
}